import { Box, FormLabel, StackProps, VStack } from '@chakra-ui/react';
import { BusinessSearchField as SharedBusinessSearchField } from '@repo/shared/shared';
import { useTranslation } from 'next-i18next';
import { useCartStoreActions } from '@/entities/cart';
import { config } from '@/shared/constants';

const BusinessSearchField = (props: StackProps) => {
  const { t } = useTranslation();
  const { setGoogleProfile } = useCartStoreActions();

  return (
    <VStack
      alignItems='start'
      bg='bg.light'
      borderColor='border.medium'
      borderRadius='lg'
      borderWidth='1px'
      pt='md'
      px='md'
      w='full'
      {...props}
    >
      <FormLabel
        fontWeight='semibold'
        mb='0'
      >
        {t('store.product.businessSearch.label')}
      </FormLabel>
      <Box color='text.medium'>{t('store.product.businessSearch.description')}</Box>
      <SharedBusinessSearchField
        bg='transparent'
        borderRadius={0}
        boxShadow='none'
        googlePlacesConfig={{
          countryRestriction: config.countryCode,
          baseUrl: config.apiUrl,
        }}
        isRequired
        name='googleBusinessProfile'
        pt={0}
        px={0}
        onChange={(option) => {
          setGoogleProfile(
            option
              ? {
                  placeId: option.value,
                  name: option.label,
                }
              : null,
          );
        }}
      />
    </VStack>
  );
};

export default BusinessSearchField;
